export default __webpack_public_path__ + "static/media/aivar_full.be5fbe65.jpg";